<template>
<div id="term-policy" class="shadow-md rounded-item">
  <vx-card>
    <div class="setting-card-hidden">
      <div class="setting-card-scroll">
        <vs-tabs id="term-policy-tabs" v-model="active_tab" vs-position="top">
          <vs-tab label="Liability policies">
            <div class="flex align-start py-6">
              <feather-icon icon="HelpCircleIcon" svgClasses="w-5 stroke-current"/>
              <span class="ml-4 d-inline-block">
                You can add your liability policies here so customers will need to agree with it when they check in on the ipad.
              </span>
            </div>
            <!-- <div class="flex align-center mb-6">
              <vs-switch v-model="liability_switch" class="mr-4"/>
              <span>Require form when booking.</span>
            </div> -->
            <transition name="list">
              <div>
                <div>
                  <!-- <vue-editor v-model="content" v-if="liability_switch"></vue-editor> -->
                  <vue-editor v-model="liability_policy"></vue-editor>
                </div>
                <vs-checkbox v-model="liability_confirm">{{by_checking_content}}</vs-checkbox>
                
                <div class="flex flex-wrap justify-between align-center">
                  <div style="padding-top:50px;">
                    <vs-button color="primary" type="filled" class="w-full rounded-item text-sm gradient gradient-primary no-shadow" @click="updateTermPolicy('liability')" v-if="liability_confirm">Save</vs-button>
                    <vs-button color="primary" type="filled" class="w-full rounded-item text-sm gradient gradient-primary no-shadow" disabled v-else>Save</vs-button>
                  </div>
                </div>
              </div>
            </transition>
          </vs-tab>

          <vs-tab label="Cancellation policies">
            <div class="flex align-start py-6">
              <feather-icon icon="HelpCircleIcon" svgClasses="w-5 stroke-current"/>
              <span class="ml-4 d-inline-block">
                You can add your booking cancellation policies here so customers will need to agree with it when they check in on the ipad.
              </span>
            </div>
            <div>
              <vue-editor v-model="cancellation_policy"></vue-editor>
            </div>
            <div class="flex flex-wrap justify-between align-center">
              <div style="padding-top:50px;">
                <vs-button color="primary" type="filled" class="w-full rounded-item text-sm gradient gradient-primary no-shadow" @click="updateTermPolicy('cancellation-policies')">Save</vs-button>
              </div>
            </div>
          </vs-tab>

          <vs-tab label="Other policies">
            <div class="flex align-start py-6">
              <feather-icon icon="HelpCircleIcon" svgClasses="w-5 stroke-current"/>
              <span class="ml-4 d-inline-block">
                You can add your other policies here so customers will need to agree with it when they check in on the ipad.
              </span>
            </div>
            <!-- <div class="flex align-center mb-6">
              <vs-switch v-model="liability_switch" class="mr-4"/>
              <span>Require form when booking.</span>
            </div> -->
            <!-- <div class="flex align-center mb-6">
              <vs-checkbox class="m-0" v-model="other_switch" style="transform: translateY(-2px)"></vs-checkbox>
              <span>Click to use <span class="text-primary cursor-pointer user-select-none" @click="defaultPolicyPopupConfig = true">default policy template</span></span>
            </div> -->
            <vs-popup class="default-policy-popup" title="Default Policy Content" :active.sync="defaultPolicyPopupConfig">
              <div class="pt-4">
                  <!-- <vs-textarea v-model="defaultPolicyContent" height="400" readonly/> -->
                  <vue-editor v-model="defaultPolicyContent" disabled></vue-editor>
              </div>
            </vs-popup>
            <transition name="list">
              <div>
                <div>
                  <!-- <vue-editor v-model="content" v-if="other_switch"></vue-editor> -->
                  <vue-editor v-model="other_policy" disabled v-if="other_switch"></vue-editor>
                  <vue-editor v-model="other_policy" v-else></vue-editor>
                </div>
                <!-- <vs-checkbox v-model="other_confirm">{{by_checking_content}}</vs-checkbox> -->
                <div class="flex flex-wrap justify-between align-center">
                  <div style="padding-top:50px;">
                    <vs-button color="primary" type="filled" class="w-full rounded-item text-sm gradient gradient-primary no-shadow" @click="updateTermPolicy('other')">Save</vs-button>
                    <!-- <vs-button color="primary" type="filled" class="w-full rounded-item text-sm gradient gradient-primary no-shadow" disabled v-else>Save</vs-button> -->
                  </div>
                </div>
              </div>
            </transition>
          </vs-tab>
          <!-- <div>
            <vue-editor v-model="content" style="height:400px;"></vue-editor>
          </div>
          <div class="flex flex-wrap justify-between align-center">
            <div style="padding-top:100px;">
              <vs-button color="primary" type="filled" class="w-full rounded-item text-sm gradient gradient-primary no-shadow" @click="updateTermPolicy">Save</vs-button>
            </div>
          </div> -->
        </vs-tabs>
      </div>
    </div>
  </vx-card>
</div>
</template>
<script>
import { VueEditor } from "vue2-editor";
export default {
  name: 'vs-term-policy',
  components: {
    VueEditor
  },
  data(){
    return{
      liability_policy : '',
      other_policy : '',
      cancellation_policy: '',
      content: '',
      isOpenLoading: false,
      loaded_data_num: 0,
      liability_switch: false,
      other_switch: false,
      liability_confirm: false,
      other_confirm: false,
      by_checking_content: 'By checking the box, I am the business owner and understand that this template is just the suggestion from Go Check In and Go Check In will not bear any responsibility of the above content.',
      defaultPolicyPopupConfig: false,
      defaultPolicyContent: `<p>I acknowledge the contagious nature of the Coronavirus/COVID-19 and that the CDC and many other public health authorities still recommend practicing social distancing.</p><p>I further acknowledge that the business cannot guarantee that I will not become infected with the Coronavirus/Covid-19. I understand that the risk of becoming exposed to and/or infected by the Coronavirus/COVID-19 may result from the actions, omissions, or negligence of myself and others, including, but not limited to, salon staff, and other salon clients and their families.</p><p>I voluntarily seek services and acknowledge that I am increasing my risk to exposure to the Coronavirus/COVID-19. I acknowledge that I must comply with all set procedures to reduce the spread while attending my appointment.</p><p>I attest that:</p><ul><li>I am not experiencing any symptom of illness such as cough, shortness of breath or difficulty breathing, fever, chills, repeated shaking with chills, muscle pain, headache, sore throat, or new loss of taste or smell.</li><li>I have not traveled internationally within the last 14 days.</li><li>I have not traveled to a highly impacted area within the United States of America in the last 14 days.</li><li>I do not believe I have been exposed to someone with a suspected and/or confirmed case of the Coronavirus/COVID-19.</li><li>I have not been diagnosed with Coronavirus/Covid-19 and not yet cleared as non-contagious by state or local public health authorities.</li><li>I am following all CDC recommended guidelines as much as possible and limiting my exposure to the Coronavirus/COVID-19.</li><li>I hereby release and agree to hold this business harmless from, and waive on behalf of myself, my heirs, and any personal representatives any and all causes of action, claims, demands, damages, costs, expenses and compensation for damage or loss to myself and/or property that may be caused by any act, or failure to act of the salon, or that may otherwise arise in any way in connection with any services received. I understand that this release discharges this business from any liability or claim that I, my heirs, or any personal representatives may have against the salon with respect to any bodily injury, illness, death, medical treatment, or property damage that may arise from, or in connection to, any services received from this business. This liability waiver and release extends to the salon together with all owners, partners, and employees.</li></ul><p><br></p>`,
      active_tab: 0
    }
  },
  watch: {
    loaded_data_num: {
      immediate: true,
      handler() {
        if(this.loaded_data_num >= 1) {
          this.closeLoading();
        } else {
          this.action_type = "Get data";
          this.openLoadingInDiv();
        }
      }
    },
    other_switch: {
      immediate: true,
      handler() {
        if(this.other_switch) {
          this.$vs.dialog({
              color: 'danger',
              title: 'Notification',
              text: 'You have to check the agreement checkbox below and press "Save" button to apply this change!!',
              acceptText: 'OK'
            })
        }
      }
    },
    active_tab: {
      immediate: true,
      handler() {
        if(this.$store.getters["appSetting/policyData"]) {
          let policy = this.$store.getters["appSetting/policyData"];
          this.liability_policy = '';
          this.other_policy = '';
          this.cancellation_policy = '';
          if(policy && policy.length > 0) {
            for(let i = 0; i < policy.length; i++) {
              if(policy[i].slug == 'liability-policies') {
                this.liability_policy = policy[i].body;
              } else if(policy[i].slug == 'other-policies') {
                this.other_policy = policy[i].body;
              } else if(policy[i].slug == 'cancellation-policies') {
                this.cancellation_policy = policy[i].body;
              }
            }
          }
          this.liability_confirm = false;
          this.other_confirm = false;
          this.other_switch = false;
        }
      }
    }
  },
  methods:{
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      this.isOpenLoading = true;
      setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: 'Update term policy failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: 'Update term policy failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    updateTermPolicy(type){
      let obj = {}
      if(type == 'liability'){
        obj = {
          type: 'liability-policies',
          value: this.liability_policy
        }
      }else if(type == 'other'){
        if(this.other_switch == true){
          obj = {
            type: 'default_other_policy',
            // value: this.defaultPolicyContent
          }
        }else{
          obj = {
            type: 'other-policies',
            value: this.other_policy
          }
        }
      } else if(type == 'cancellation-policies') {
        obj = {
          type: 'cancellation-policies',
          value: this.cancellation_policy
        }
      }
      this.$store.dispatch("appSetting/UPDATE_TERM_POLICY", obj).then(() => {
        this.$vs.notify({
          title:'Success',
          text:'Update Term Policy Success',
          color:'success',
          position:'top-right'
        })
        if(this.other_switch && type == 'other') {
          this.other_policy = this.defaultPolicyContent;
        }
        this.other_switch = false;
        this.other_confirm = false;
        this.liability_confirm = false;
      }).catch(() => {
        this.$vs.notify({
          title:'Fail',
          text:'Update Term Policy Failed',
          color:'danger',
          position:'top-right'
        })
      })
    }
  },
  computed:{
    policyData(){
      return this.$store.getters["appSetting/policyData"];
    }
  },
  created(){
    this.$store.dispatch("appSetting/GET_POLICIES").then(() => {
      let policy = {}
      policy = this.$store.getters["appSetting/policyData"];
      this.liability_policy = '';
      this.other_policy = '';
      this.cancellation_policy = '';
      if(policy && policy.length > 0) {
        for(let i = 0; i < policy.length; i++) {
          if(policy[i].slug == 'liability-policies') {
            this.liability_policy = policy[i].body;
          } else if(policy[i].slug == 'other-policies') {
            this.other_policy = policy[i].body;
          } else if(policy[i].slug == 'cancellation-policies') {
            this.cancellation_policy = policy[i].body;
          }
        }
      }
      // if(policy){
      //   this.liability_policy = policy.liability_policy.body;
      //   this.other_policy = policy.other_policy.body;
      // }
    });
    const obj = {
      key: 'config.terms_policy.content'
    }
    this.$store.dispatch("appSetting/GET_KEY_STORAGE" ,obj).then(() => {
      let termPolicy = {}
      termPolicy = this.$store.getters["appSetting/keyStorage"];
      this.content = termPolicy.value;
      this.loaded_data_num++;
    }).catch(() => {
      const obj = {
        key: 'config.terms_policy.content',
        value: '<h1>Terms &amp; Policy</h1>'
      }
      this.$store.dispatch("appSetting/ADD_KEY_STORAGE", obj).then(() => {
        this.loaded_data_num++;
      })
    })
  }
}
</script>
